import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { apiErr } from "../lib/api";
import { translate } from "../lib/i18n";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

export function AppProvider({ children }) {
    const [user, setUser] = useState(null); // null = checking, false = logged out, obj = user
    const [language, setLanguageState] = useState("en");
    const [config, setConfig] = useState(null);

    const refreshUser = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
            return data;
        } catch {
            setUser(false);
            return false;
        }
    }, []);

    useEffect(() => {
        refreshUser();
        api.get("/config").then(({ data }) => setConfig(data)).catch(() => {});
    }, [refreshUser]);

    const setLanguage = useCallback(async () => {}, []);

    const login = useCallback(async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        setUser(data);
        return data;
    }, []);

    const logout = useCallback(async () => {
        try { await api.post("/auth/logout"); } catch {}
        setUser(false);
    }, []);

    const t = useCallback((key, vars) => translate(language, key, vars), [language]);

    return (
        <AppContext.Provider value={{ user, setUser, language, setLanguage, config, setConfig, refreshUser, login, logout, t, apiErr }}>
            {children}
        </AppContext.Provider>
    );
}
